import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
export function StickyBottomBar() {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const offerSection = document.getElementById('offer');
    if (!offerSection) return;
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(!entry.isIntersecting);
    }, {
      threshold: 0.1,
      rootMargin: '0px'
    });
    observer.observe(offerSection);
    return () => {
      observer.disconnect();
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-brand-violet to-[#5A4B81] shadow-2xl z-40 border-t border-white/10" data-id="element-335">
      <div className="container mx-auto px-4 py-3 md:py-4" data-id="element-336">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-6" data-id="element-337">
          {/* Left: Product Name */}
          <div className="hidden md:block" data-id="element-338">
            <h3 className="font-serif text-lg md:text-xl text-brand-cream font-medium" data-id="element-339">
              Viaje a tu Interior
            </h3>
          </div>

          {/* Center: Pricing */}
          <div className="flex items-center gap-2 md:gap-3 text-brand-cream" data-id="element-340">
            <span className="text-sm md:text-base line-through opacity-70" data-id="element-341">
              $30.000
            </span>
            <span className="text-sm md:text-base" data-id="element-342">→</span>
            <span className="text-lg md:text-2xl font-serif font-bold" data-id="element-343">
              $13.999 ARS
            </span>
          </div>

          {/* Right: CTA Button */}
          <a href="https://shop.viajeatuinterior.online/cart/43576136040526:1?storefront=true" onClick={() => {
          if (typeof window !== 'undefined' && window.fbq) {
            window.fbq('track', 'AddToCart');
          }
        }} className="w-full md:w-auto inline-flex items-center justify-center px-6 md:px-8 py-3 md:py-3.5 bg-[#F5F0E8] text-[#4A1D6E] font-bold text-sm md:text-base tracking-wide rounded-sm hover:bg-white transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-344">
            COMENZÁ TU VIAJE
            <ArrowRight className="w-4 h-4 ml-2" data-id="element-345" />
          </a>
        </div>
      </div>
    </div>;
}